import { MilestoneDisplayModel } from "@/api/model-index";
import { AnfrageService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
  })
  export class GetAnfrageReportMilestonesDataResolver  {
    constructor(protected anfrageService: AnfrageService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService){}
  
    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<MilestoneDisplayModel[] | undefined> {
      let id: string = <string>route.params['id'];
      let reportId: string = <string>route.params['reportid'];

      await this.unfinishedHttpMethodsService.waitByUrl(state.url);

      if(this.portalContextService.CurrentAnfrage && this.portalContextService.CurrentAnfrage.id == id && this.portalContextService.CurrentAnfrage.id && this.portalContextService.CurrentAnfrage.milestones)
        //if (!this.portalContextService.CurrentBericht || (this.portalContextService.CurrentBericht && this.portalContextService.CurrentBericht.projektberichtId == reportId))
        if (!this.portalContextService.CurrentBericht) // Todo: Caching is not working with berichte
          return of(this.portalContextService.CurrentAnfrage.milestones).toPromise();
        
      return this.anfrageService.apiAnfrageGetAllMilestoneAnfrageIdGet({ anfrageId: id }).pipe(map(response => {
        if(response){
          if(this.portalContextService.CurrentAnfrage?.id == id && !this.portalContextService.CurrentAnfrage?.milestones || this.portalContextService.CurrentBericht)
            this.portalContextService.CurrentAnfrage.milestones = response;

          if(this.portalContextService.CurrentAnfrage?.milestones)
            return this.portalContextService.CurrentAnfrage.milestones;
        }

        return undefined;
      })).toPromise();
    }
  }